module.exports = __webpack_public_path__ + "img/奖品-本草纲目.b0917068.png";